export default __webpack_public_path__ + "static/media/maxresdefault.78bf07c6.jpg";